var render = function render(_c,_vm){return _c('span',_vm._b({staticClass:"v-spinner",class:[_vm.data.staticClass, _vm.data.class]},'span',_vm.data.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }